import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import {
  EXTERNAL_TYPE,
  IMAGE_TYPE,
  VIDEO_TYPE,
  DOCUMENT_TYPE,
} from 'hb-react/shared/utils/files/fileContentTypes';

const EMPTY_CONTENT_ID = BLOCKS.emptyContent.id;
const FILTERS_ID = BLOCKS.filters.id;
const FULLTEXT_FILTER_ID = 'fulltext';
const TYPE_FILTER_ID = 'type';

export { EMPTY_CONTENT_ID, FILTERS_ID, FULLTEXT_FILTER_ID, TYPE_FILTER_ID };

export const TYPE_OPTIONS = [
  {
    label: __('Images'),
    value: IMAGE_TYPE,
  },
  {
    label: __('Videos'),
    value: VIDEO_TYPE,
  },
  {
    label: __('Documents'),
    value: DOCUMENT_TYPE,
  },
  {
    label: s__('MediaCenter|External links'),
    value: EXTERNAL_TYPE,
  },
];

export const SORT_BY = [
  {
    label: s__('MediaCenter|Oldest'),
    value: 'old',
  },
  {
    label: s__('MediaCenter|Newest'),
    value: 'new',
  },
  {
    label: s__('MediaCenter|A-Z name'),
    value: 'asc',
  },
  {
    label: s__('MediaCenter|Z-A name'),
    value: 'desc',
  },
];

export const SORT_BY_FOR_API = {
  old: {
    sort_by: 'updated_at',
    order: 'asc',
  },
  new: {
    sort_by: 'updated_at',
    order: 'desc',
  },
  asc: {
    sort_by: 'name',
    order: 'asc',
  },
  desc: {
    sort_by: 'name',
    order: 'desc',
  },
};

export const FOLDERS_PER_PAGE = {
  xl: 8,
  l: 6,
  m: 4,
  s: 4,
};

export const ITEMS_BY_ROW = {
  xl: 4,
  l: 3,
  m: 2,
  s: 1,
};

export const TAGS_LIMIT = {
  xl: 10,
  l: 10,
  m: 4,
  s: 4,
};
